import { render, staticRenderFns } from "./AdminSettingPermissionItem.vue?vue&type=template&id=7e928f56&scoped=true&"
import script from "./AdminSettingPermissionItem.vue?vue&type=script&lang=js&"
export * from "./AdminSettingPermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingPermissionItem.vue?vue&type=style&index=0&id=7e928f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e928f56",
  null
  
)

export default component.exports